import { Component } from '@angular/core';


@Component({
  selector: 'glxy-transcript-entry-loading-state',
  standalone: true,
  imports: [],
  templateUrl: './transcript-entry-loading-state.component.html',
  styleUrls: ['./transcript-entry-loading-state.component.scss'],
})
export class TranscriptEntryLoadingStateComponent {}
